
/* eslint-disable @typescript-eslint/no-shadow */
export namespace QuestionType {
  export enum QuestionType {
    OPEN_ENDED = "OPEN_ENDED",
    SINGLE_CHOICE = "SINGLE_CHOICE",
    MULTIPLE_CHOICE = "MULTIPLE_CHOICE",
    GRID = "GRID",
    GROUP = "GROUP",
    RANKING = "RANKING",
    MESSAGE = "MESSAGE",
  }

  export interface QuestionTypeDTO {
    case: string;
  }

  export const fromDTO = (dto: QuestionTypeDTO): QuestionType => {
    if (dto === undefined || dto === null) {
      throw new InvalidQuestionTypeError(
        `Invalid DTO ${dto} provided for QuestionType.QuestionType`
      );
    }
    switch (dto.case) {
      case "OPEN_ENDED":
        return QuestionType.OPEN_ENDED;
      case "SINGLE_CHOICE":
        return QuestionType.SINGLE_CHOICE;
      case "MULTIPLE_CHOICE":
        return QuestionType.MULTIPLE_CHOICE;
      case "GRID":
        return QuestionType.GRID;
      case "GROUP":
        return QuestionType.GROUP;
      case "RANKING":
        return QuestionType.RANKING;
      case "MESSAGE":
        return QuestionType.MESSAGE;
      default:
        throw new InvalidQuestionTypeError(
          `Case ${dto.case} is not valid case of QuestionType.QuestionType`
        );
    }
  };

  export const toDTO = (questionType: QuestionType): QuestionTypeDTO => {
    const enumDTO = {
      case: QuestionType[questionType],
    };
    return enumDTO;
  };
}

export class InvalidQuestionTypeError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuestionTypeError";
  }
}
export class InvalidQuestionTypeOpenEndedError extends InvalidQuestionTypeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuestionTypeOpenEndedError";
  }
}

export class InvalidQuestionTypeSingleChoiceError extends InvalidQuestionTypeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuestionTypeSingleChoiceError";
  }
}

export class InvalidQuestionTypeMultipleChoiceError extends InvalidQuestionTypeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuestionTypeMultipleChoiceError";
  }
}

export class InvalidQuestionTypeGridError extends InvalidQuestionTypeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuestionTypeGridError";
  }
}

export class InvalidQuestionTypeGroupError extends InvalidQuestionTypeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuestionTypeGroupError";
  }
}

export class InvalidQuestionTypeRankingError extends InvalidQuestionTypeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuestionTypeRankingError";
  }
}

export class InvalidQuestionTypeMessageError extends InvalidQuestionTypeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuestionTypeMessageError";
  }
}
